import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";
import { filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getDisclaimers = createAsyncThunk(
  "disclaimers/getDisclaimers",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query = "", owner, user, filter = {} } = args;

      // Filter out empty values from filter object
      const cleanFilter = Object.keys(filter).reduce((acc, key) => {
        if (filter[key]) {
          acc[key] = filter[key];
        }
        return acc;
      }, {});

      const filterStr = filterRequest(cleanFilter);
      let url = `/disclaimers?page=${page}&size=${size}`;
      if (query) url += `&query=${query}`;
      if (owner) url += `&owner=${owner}`;
      if (user) url += `&user=${user}`;
      url += filterStr;

      const { data } = await axiosInstance.get(url);
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const sendDocument = createAsyncThunk(
  "disclaimers/sendDocument",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/disclaimers/${args._id}/send_document`,
        args
      )
      
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const disclaimersSlice = createSlice({
  name: "disclaimers",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getDisclaimers.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getDisclaimers.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      // Handle both possible API response structures
      state.data = payload.data?.data || payload.data || [];
      state.pages = payload.data?.pages || payload.pages || 0;
      state.itemsCount = payload.data?.itemsCount || payload.itemsCount || 0;
      state.error = null;
    });
    builder.addCase(getDisclaimers.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload?.message;
    });

    builder.addCase(sendDocument.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(sendDocument.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(sendDocument.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload?.message;
    });
  },
});

export default disclaimersSlice.reducer;
